export default "__VITE_ASSET__CZ_Tqufh__"